export default () => {
  return {
    'event': 'receipt_mail',
    'funnel_name': 'MYB',
    'sub_funnel_name': 'Confirmation',
  };
};